
import { Component, Vue, Prop } from 'vue-property-decorator';
import { AppIds } from '@/consts';

@Component
export default class AboutPage extends Vue {
  @Prop({ default: false }) private narrow!: boolean;
  @Prop({ default: true }) private showPoster!: boolean;

  private fetchedHtml = '';
  private posterSrc = '../../../themes/bg/images/rise-about-poster.jpg';
  private posterLoaded = false;

  async created() {
    await this.getContent();
  }

  get appId() {
    return this.$store.getters.appId as AppIds;
  }

  get version() {
    return `${this.$t('about.version')}: ${this.$store.state.version}`;
  }

  get lastUpdate() {
    return `${this.$t('about.last_update')}: ${this.$store.state.buildDate}`;
  }

  get showContent() {
    // Temporary: only show for BG, until we make the content configurable.
    const client = this.$store.getters['auth/clientDetails'];
    const themeName = client ? client.theme_name : 'default';
    return themeName === 'bg';
  }

  get showFetchedContent() {
    return this.fetchedHtml.length;
  }

  async getContent() {
    const client = this.$store.getters['auth/clientDetails'];
    if (!client || !client.theme_url) {
      return;
    }
    const htmlUrl = client.theme_url.replace('theme.css', `about/${this.appId}-${this.$i18n.locale}.html`);

    // Fetch HTML
    try {
      const response = await fetch(htmlUrl);

      // Check if the response is okay (status code 200-299)
      if (response.ok) {
        const fetchedHtml = await response.text();
        // Exclude responses containing html tags (error pages)
        this.fetchedHtml = fetchedHtml.includes('<html') ? '' : fetchedHtml;
      } else {
        // Fail silently
        // console.error(`Failed to fetch content: ${response.statusText}`);
      }
    } catch (error) {
      // Fail silently
      // console.error('Error fetching localized content:', error);
    }

    // Static rise poster
    // Consider updating this at a future date if the about page changes for others
    this.posterSrc = client.theme_url.replace('theme.css', 'images/rise-about-poster.jpg');
    const posterUrl = client.theme_url.replace('theme.css', `about/poster-${this.$i18n.locale}.jpg`);
    // Create a new image element to test if the image exists
    const img = new Image();
    img.src = posterUrl;

    // If the image loads, update the posterSrc; otherwise, it will keep the fallback
    img.onload = () => {
      this.posterSrc = posterUrl;
    };

    this.posterLoaded = true;
  }
}
